/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Matching_Score_Algorithm_Academic_Title_MismatchInputs */

const en_matching_score_algorithm_academic_title_mismatch = /** @type {(inputs: Matching_Score_Algorithm_Academic_Title_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Academic title does not match any expected titles`)
};

const de_matching_score_algorithm_academic_title_mismatch = /** @type {(inputs: Matching_Score_Algorithm_Academic_Title_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akademischer Titel entspricht keinem der erwarteten Titel`)
};

/**
* | output |
* | --- |
* | "Academic title does not match any expected titles" |
*
* @param {Matching_Score_Algorithm_Academic_Title_MismatchInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const matching_score_algorithm_academic_title_mismatch = /** @type {((inputs?: Matching_Score_Algorithm_Academic_Title_MismatchInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Matching_Score_Algorithm_Academic_Title_MismatchInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_matching_score_algorithm_academic_title_mismatch(inputs)
	return en_matching_score_algorithm_academic_title_mismatch(inputs)
});